import { APP_PERMISSIONS } from '@exam-management/permissions';

export const EDIT_QCONFIG_REQUIRED_PERMISSIONS = [
  APP_PERMISSIONS.EXAM.QCONFIG.UPDATE,
  APP_PERMISSIONS.QBANK.STRUCTURE.VIEW,
  APP_PERMISSIONS.QBANK.QUESTION.VIEW,
];

export const ADD_QBANK_REQUIRED_PERMISSIONS = [
  APP_PERMISSIONS.QBANK.STRUCTURE.VIEW,
  APP_PERMISSIONS.EXAM.QCONFIG.UPDATE,
];
